var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "60vh"
        }
      },
      on: {
        hide: function($event) {
          return _vm.hideBillingReports()
        }
      },
      model: {
        value: _vm.show_billing_reports_modal,
        callback: function($$v) {
          _vm.show_billing_reports_modal = $$v
        },
        expression: "show_billing_reports_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    return _vm.hideBillingReports()
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("billing_reports")) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "q-ma-md q-pa-md col-xs-12 col-sm-12" },
            [
              _c("q-table", {
                staticClass: "q-mt-md",
                attrs: {
                  data: _vm.billing_reports,
                  columns: _vm.columns,
                  loading: _vm.loading,
                  "row-key": "id",
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "no-results-label": _vm.$t("no_results_found"),
                  "loading-label": _vm.$t("loading_data"),
                  "rows-per-page-label": _vm.$t("items_per_page"),
                  "rows-per-page-options": [5, 10, 50, 100],
                  "binary-state-sort": ""
                },
                on: { request: _vm.requestReports },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        {},
                        [
                          _c(
                            "q-td",
                            {
                              key: "download_link",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _c("q-btn", {
                                attrs: {
                                  flat: "",
                                  color: "secondary",
                                  icon: "fas fa-download"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadReport(
                                      props.row.download_link
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            { key: "report", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.row.report) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "timeline", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.row.timeline) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }